import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={34} height={26} {...props}>
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h34v26H0z" />
        </clipPath>
      </defs>
      <g fill="#004f89" clipPath="url(#prefix__a)">
        <path
          data-name="Path 5619"
          d="M22.332 11.617a.234.234 0 01-.142.3c-.551.194-1.086.385-1.625.563a.229.229 0 00-.186.265c.006 1.8 0 3.6 0 5.407a.234.234 0 01-.234.234h-6.607a.234.234 0 01-.234-.234v-.018-5.388a.242.242 0 00-.2-.275c-.533-.178-1.061-.367-1.6-.559a.235.235 0 01-.142-.3l.122-.329c.352-.946.706-1.891 1.055-2.838a.271.271 0 01.219-.195c.847-.205 1.69-.423 2.537-.629a.424.424 0 01.249.016 3.212 3.212 0 002.614 0 .361.361 0 01.213-.022q1.3.318 2.59.651a.277.277 0 01.171.139c.4 1.064.796 2.131 1.2 3.212z"
        />
        <g data-name="Path 5622">
          <path d="M20.465 18.083l-.353-.353-.26-.258-.781-.78-.25-.249H17.369v-2.508h1.478l.242-.24.762-.757.28-.278.353-.35.352.351 1.128 1.126 1.046 1.044.354.353-.354.354-1.07 1.072-1.12 1.12-.354.353z" />
          <path
            d="M20.465 17.376l2.19-2.191-2.173-2.17-1.042 1.035.363.385h-1.935v1.508h1.92l-.364.395 1.04 1.038m.002 1.414l-1.851-1.847h-1.747v-3.508h1.772l.096-.095.761-.756.987-.98 3.586 3.58-3.604 3.606z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
